import type { LiveInputs, LiveInputsPostLinkInterface } from '../../types'
import type Tooltip from '@app/setup/tooltip/uikit-tooltip'

class LiveInputsNewRowLink implements LiveInputsPostLinkInterface {
  private liveInputs: LiveInputs
  private inputFilter: string = "[data-behaviour~='live-inputs-new-row-link']"

  constructor(liveInputs: LiveInputs) {
    this.liveInputs = liveInputs
    this.initializeListeners()
  }

  private initializeListeners(): void {
    this.liveInputs.on('click', this.inputFilter, this.handleClick)
  }

  // HandleClick is auto-bound as a stable reference
  handleClick = (event: Event): void => {
    event.preventDefault()

    const target = event.target as HTMLElement

    if (!target) {
      return
    }

    const tooltip = $(target).data('tooltip-instance') as Tooltip
    if (tooltip) {
      tooltip.dispose()
    }

    this.liveInputs.setTabDirection(0)
    this.liveInputs.update($(target), {
      renderTooltips: false,
      submit: true,
      new_row_button: true,
    })
  }

  teardown(): void {
    this.liveInputs.off('click', this.inputFilter, this.handleClick)
  }
}

export default LiveInputsNewRowLink
